<div [id]="elementId" (click)="toggleDropdown()">
  @if (!ppAssigneeId) {
    <pp-button ppStyle="secondary" ppSize="x-small">
      <span class="newAssigneeLabelButtonText">
        {{ 'new_asset_label_new_assignee_button' | ppTranslate }}
      </span>
    </pp-button>
  }

  @if (ppAssigneeId && users[ppAssigneeId]) {
    <img
      ppTooltip
      [ppTitle]="users[ppAssigneeId].userName"
      class="newAssetLabelUser"
      [src]="users[ppAssigneeId].avatarPublicUrl"
      />
  }
  @if (ppAssigneeId && !users[ppAssigneeId]) {
    <img
      class="newAssetLabelUser"
      [src]="EIconPath.PLACEHOLDER_USER"
      />
  }
</div>
